import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { asset, machineProfile } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { formatNumber, Loader } from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import { matar } from "../../../api/index.js";
import { assetData } from "../data-sample";

function MachineList() {
  const [datas, setDatas] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  async function getData(forcePage) {
    try {
      setLoading(true);
      const res = await matar.getGroupMatar({ withDetail: true });
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setDatas(data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    // wait for 1 second before calling getData
    const timer = setTimeout(() => {
      if (search) {
        const queryParam = {
          ...query,
          search: search.toUpperCase(),
        };
        setQuery(queryParam);
      } else {
        setQuery({ company: true });
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [search]);

  useEffect(() => {
    getData();
  }, [page]);
  useEffect(() => {
    setPage(1);
    getData(1);
  }, [query]);

  function calculateTotalCAPEX(data) {
    let total = 0;
    if (data) {
      data.forEach((d) => {
        const f = d.machine?.MachineStrategies.find((d) => d.default_capex);
        if (f) {
          total += f.default_capex;
        }
      });
    }
    return formatNumber(total);
  }

  const columns = [
    {
      name: "Group Name",
      selector: (row) => row.name,
    },
    {
      name: "Total Asset",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.MachineGroup?.length}</span>;
      },
    },
    {
      name: "Total CAPEX Cost",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>$ {calculateTotalCAPEX(row.MachineGroup)}</span>;
      },
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div className={"d-flex"}>
            <button
              className="btn btn-sm btn-outline-theme mx-1"
              onClick={() =>
                navigate("/machine-asset/investment-group/" + row["id"])
              }
            >
              View Detail
            </button>
          </div>
        );
      },
    },
  ];

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Asset</a>
            </li>
            <li className="breadcrumb-item active">Asset List</li>
          </ul>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0"></div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        paginationPerPage={20}
                        paginationRowsPerPageOptions={[20]}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationTotalRows={totalPage * 20}
                        onChangePage={handlePageChange}
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
